// extracted by mini-css-extract-plugin
export default {"bl-input-label":"BLLabel_bl-input-label__F1ODM"};